import postRetryTranscript from "@/services/postRetryTranscript";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import useToast from "../../contexts/Toast/useToast";
import { reportError } from "@/utils/reportError";

export const usePostRetryTranscript = () => {
  const { showErrorToast } = useToast();

  const queryClient = useQueryClient();

  const { mutate, isPending, isError, error, data } = useMutation({
    mutationFn: async ({ recordingId }: { recordingId: string }) => await postRetryTranscript(recordingId),
    mutationKey: ["postRetryTranscript"],
    onError: (error: AxiosError) => {
      console.error("Error retrying transcript:", error);
      showErrorToast("failMessage.toast");
      reportError(error, {
        eventName: "POST-RETRY-TRANSCRIPT",
        properties: {
          reason: "Error with retry transcript request",
          baseURL: error?.config?.baseURL,
          data: error?.config?.data,
          url: error?.config?.url,
        },
      });
    },
    onSuccess: (_, { recordingId }) => {
      console.info(`Retry transcript successful for ${recordingId}`);
      queryClient.invalidateQueries({ queryKey: ["recordingSubjects"] });
    },
  });

  return { mutate, isPending, isError, error, data };
};

export default usePostRetryTranscript;
